// extracted by mini-css-extract-plugin
module.exports = {"hr":"AccountSignupForm--hr--DXCac","hr-text":"AccountSignupForm--hr-text--3Jueu","hrText":"AccountSignupForm--hr-text--3Jueu"};